// This makes a thin line on the page. The styling is in index.css

import React from "react";

const Line = () => {
  return <div className="thinline"> </div>;
};

export default Line;



// WEBPACK FOOTER //
// ./src/components/7_Line/index.js